module.exports = __webpack_public_path__ + "static/media/image1.3bdea38b.jpg";